import { FC, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { PIC } from "@ryde/assets";
import { useModalConfirm, usePageContext, useRidesActions } from "@ryde/redux";
import {
  ConfirmResult,
  selectedTableRowsIdsAtomFamily,
  useIsMobile,
} from "@ryde/shared";

import { AssignDocksButtonStyled } from "./elements.styled";

export const RidesAssignDocksButton: FC = () => {
  const { t } = useTranslation();
  const { isMobile } = useIsMobile();
  const { assignDocks } = useRidesActions();
  const { entity } = usePageContext();
  const { confirmDialogResult } = useModalConfirm();
  const [isInProgress, setIsInProgress] = useState(false);
  const selectedRideIds = useRecoilValue(
    selectedTableRowsIdsAtomFamily(entity),
  );
  const isDisabled = !selectedRideIds.length || isInProgress;

  const onClick = useCallback(async () => {
    setIsInProgress(true);

    const confirmationResult = await confirmDialogResult({
      title: t("general.CONFIRM"),
      message: t(`general.ASSIGN_DOCKS_CONFIRMATION`, {
        rideCount: selectedRideIds.length,
      }),
    });

    if (confirmationResult === ConfirmResult.OK) {
      await assignDocks(selectedRideIds);
    }

    setIsInProgress(false);
  }, [assignDocks, confirmDialogResult, selectedRideIds, t]);

  return (
    <AssignDocksButtonStyled
      className={isMobile ? "icon-only" : undefined}
      muiVariant="outlined"
      muiStyle="secondary"
      onClick={onClick}
      disabled={isDisabled}
      aria-label={t("ride.assignDocks")}
    >
      {!isMobile && t("ride.assignDocks")}
      <PIC.DockSVG />
    </AssignDocksButtonStyled>
  );
};
